/* Cart: quantity changes, remove with undo, note, VAT capture, terms.
   The plain form still works without this file. */
(function () {
  'use strict';
  /* Secties nemen dit bestand elk zelf op, dus staat het soms twee of drie keer
     op één pagina. De browser voert elke tag dan opnieuw uit, waardoor listeners
     op document dubbel hangen en één klik twee acties uitvoert. Deze poort laat
     alleen de eerste uitvoering door. */
  window.__hwsLoaded = window.__hwsLoaded || {};
  if (window.__hwsLoaded['component_cart']) return;
  window.__hwsLoaded['component_cart'] = true;

  var strings = window.hwsStrings || {};
  var config = window.hwsSettings || {};
  var undoBuffer = null;

  function sections() {
    var ids = [];
    document.querySelectorAll('[data-cart-section]').forEach(function (el) {
      var id = el.getAttribute('data-cart-section');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function change(line, quantity) {
    document.querySelectorAll('[data-cart-items]').forEach(function (el) { el.setAttribute('aria-busy', 'true'); });
    return window.hwsCart.change({ line: line, quantity: quantity }).then(function (data) {
      if (data.__error) {
        if (window.hwsToast) window.hwsToast.show(data.description || strings.cartError);
        return data;
      }
      window.hwsCart.renderSections(data);
      window.hwsCart.syncCount(data);
      return data;
    }).finally(function () {
      document.querySelectorAll('[data-cart-items]').forEach(function (el) { el.removeAttribute('aria-busy'); });
    });
  }

  function showUndo(item) {
    var host = document.querySelector('[data-cart-undo]');
    if (!host) return;
    host.hidden = false;
    host.innerHTML = '';
    var text = document.createElement('span');
    text.textContent = strings.itemRemoved
      ? strings.itemRemoved.replace('{{ title }}', item.title)
      : item.title;
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'btn btn--link';
    button.textContent = strings.undo || 'Undo';
    button.addEventListener('click', function () {
      window.hwsCart.add([{ id: item.id, quantity: item.quantity, properties: item.properties }]).then(function (data) {
        if (data.__error) return;
        window.hwsCart.renderSections(data);
        window.hwsCart.fetchState().then(function (s) { window.hwsCart.syncCount(s); });
        host.hidden = true;
      });
    });
    host.appendChild(text);
    host.appendChild(button);
    if (config.undoAutoClose) {
      window.setTimeout(function () { host.hidden = true; }, config.undoDelay || 6000);
    }
  }

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-line-index] , .quantity__input[data-line-index]')) {
      var line = event.target.getAttribute('data-line-index');
      if (!line) return;
      change(Number(line), parseInt(event.target.value, 10) || 0);
      return;
    }
    if (event.target.matches('[data-cart-note]')) {
      window.hwsCart.update({ note: event.target.value });
      return;
    }
    if (event.target.matches('[name="attributes[vat_number]"]')) {
      var attrs = {};
      attrs.vat_number = event.target.value;
      window.hwsCart.update({ attributes: attrs });
      return;
    }
    if (event.target.matches('[data-vat-toggle]')) {
      var field = event.target.closest('.vat-capture').querySelector('[data-vat-field]');
      if (field) field.hidden = !event.target.checked;
    }
  });

  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-cart-remove]');
    if (!remove || !window.fetch) return;
    event.preventDefault();
    var line = Number(remove.getAttribute('data-cart-remove'));
    if (config.undoRemove) {
      window.hwsCart.fetchState().then(function (state) {
        var item = state.items[line - 1];
        if (item) {
          undoBuffer = { id: item.variant_id, quantity: item.quantity, title: item.product_title, properties: item.properties };
        }
        change(line, 0).then(function () {
          if (undoBuffer) showUndo(undoBuffer);
        });
      });
    } else {
      change(line, 0);
    }
  });

  /* Kortingscode meteen toepassen via /cart/update.js met "discount": de complete lijst codes die de wagen
     moet krijgen, dus eerst de codes die er al op staan ophalen. Nagemeten op 9-10-2026: een foute code laat
     de regels staan en komt terug met applicable: false. Werkt de nieuwe code niet, dan gaat de oude lijst
     terug, zodat er geen dode code blijft hangen die bij het afrekenen een foutmelding geeft.
     /discount/CODE nooit gebruiken: die leegt bij een typefout de hele winkelwagen. */
  var discountBusy = false;

  function discountMessage(text, kind) {
    var el = document.querySelector('[data-discount-message]');
    if (!el) return;
    el.textContent = text;
    if (kind) el.setAttribute('data-kind', kind); else el.removeAttribute('data-kind');
  }

  function applyDiscount(block) {
    var input = block.querySelector('[data-discount-input]');
    var button = block.querySelector('[data-discount-apply]');
    var code = (input.value || '').trim();
    var t = block.dataset;
    if (!code) { discountMessage(t.textEmpty, 'error'); input.focus(); return; }
    if (discountBusy) return;
    discountBusy = true;
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;

    var same = function (c) { return c.code.toUpperCase() === code.toUpperCase(); };
    var codes = function (list) { return list.map(function (c) { return c.code; }).join(','); };
    var old = [];
    var outcome = 'error';
    var last = null;

    window.hwsCart.fetchState()
      .then(function (state) {
        old = (state.discount_codes || []).filter(function (c) { return c.applicable; });
        if (old.some(same)) { outcome = 'duplicate'; return null; }
        return window.hwsCart.update({ discount: codes(old.concat([{ code: code }])) });
      })
      .then(function (data) {
        if (!data) return null;
        if (data.__error) throw new Error('update');
        last = data;
        var added = (data.discount_codes || []).filter(same)[0];
        if (added && added.applicable) {
          outcome = 'success';
          // Valt een eerdere code af omdat ze niet samen mogen, dan die er ook af.
          var keep = data.discount_codes.filter(function (c) { return c.applicable; });
          return keep.length !== data.discount_codes.length ? window.hwsCart.update({ discount: codes(keep) }) : null;
        }
        return window.hwsCart.update({ discount: codes(old) });
      })
      .then(function (data) {
        if (data && !data.__error) last = data;
        if (last) { window.hwsCart.renderSections(last); window.hwsCart.syncCount(last); }
      })
      .catch(function () { outcome = 'failed'; })
      .then(function () {
        discountBusy = false;
        // renderSections heeft het blok vervangen; het nieuwe veld en de nieuwe knop opzoeken.
        var newInput = document.querySelector('[data-discount-input]');
        var newButton = document.querySelector('[data-discount-apply]');
        if (newButton) { newButton.disabled = false; newButton.removeAttribute('aria-busy'); }
        if (outcome === 'success') {
          discountMessage(t.textSuccess.replace('__CODE__', code.toUpperCase()), 'success');
          return;
        }
        if (newInput) { newInput.value = code; newInput.focus(); }
        discountMessage(outcome === 'duplicate' ? t.textDuplicate : outcome === 'failed' ? (strings.cartError || t.textError) : t.textError, 'error');
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-discount-apply]');
    if (button && window.fetch) {
      var block = button.closest('[data-discount]');
      if (!block) return;
      event.preventDefault();
      applyDiscount(block);
      return;
    }
    // Code weghalen zonder dat de pagina herlaadt en naar boven springt.
    var remove = event.target.closest('[data-discount-remove]');
    if (!remove || !window.fetch || discountBusy) return;
    event.preventDefault();
    discountBusy = true;
    window.hwsCart.update({ discount: '' })
      .then(function (data) { if (!data.__error) { window.hwsCart.renderSections(data); window.hwsCart.syncCount(data); } else { window.location.href = remove.href; } })
      .catch(function () { window.location.href = remove.href; })
      .then(function () { discountBusy = false; });
  });

  // Enter in het veld: toepassen, niet het formulier versturen.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' || !event.target.matches || !event.target.matches('[data-discount-input]')) return;
    var block = event.target.closest('[data-discount]');
    if (!block || !window.fetch) return;
    event.preventDefault();
    applyDiscount(block);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-cart-form]');
    if (!form) return;
    var terms = form.querySelector('[data-cart-terms]');
    if (terms && !terms.checked) {
      event.preventDefault();
      var error = form.querySelector('[data-cart-terms-error]');
      if (error) error.hidden = false;
      terms.focus();
    }
  });
})();
